import React, { useState, useEffect } from 'react';
import './styles.css';
import { useGetInventoryCountRequest, useCreateInventoryRequest } from '../../../../hooks/useApi';
import InventoryCount from '../../../../components/Icons/InventoryCount';

export const FullInventoryForm = ({posId, onBack, onClose, onSuccess}) =>
{
  const [inventoryName, setInventoryName] = useState('');
  const [count, setCount] = useState(0);
  const [isCreating, setIsCreating] = useState(false);

  const [{data: countData, loading: loadingCount}, getCount] = useGetInventoryCountRequest(posId);
  const [{data: createData, loading: creating, error: createError}, createInventory] = useCreateInventoryRequest(posId);

  useEffect(() =>
  {
    // Get count for full inventory (no filters)
    getCount({
      bodyParams: {
        inventoryType: 'FULL'
      }
    });
  }, []);

  useEffect(() =>
  {
    if (countData !== null && countData !== undefined)
    {
      setCount(countData);
    }
  }, [countData]);

  useEffect(() =>
  {
    if (createData && !creating && !createError)
    {
      onSuccess?.();
      onClose();
    }
  }, [createData, creating, createError]);

  const handleCreate = () =>
  {
    if (!inventoryName.trim())
    {
      alert('Please enter an inventory name');
      return;
    }

    setIsCreating(true);
    createInventory({
      bodyParams: {
        inventoryType: 'FULL',
        name: inventoryName.trim()
      }
    });
  };

  return (
    <>
      <div className="modal-header">
        <button className="back-button" onClick={onBack}>‹</button>
        <h2 className="modal-title">Create Full Inventory</h2>
        <button className="modal-close" onClick={onClose}>×</button>
      </div>

      <div className="modal-body">
        <div className="form-group">
          <label className="form-label">Inventory Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="INV 2"
            value={inventoryName}
            onChange={(e) => setInventoryName(e.target.value)}
          />
        </div>

        <div className="inventory-info-section">
          <h3 className="section-title">Inventory Information</h3>

          <div className="info-card">
            <div className="info-icon">
              <InventoryCount/>
            </div>
            <div className="info-content">
              <span className="info-value">{loadingCount ? '...' : `${count} pcs`}</span>
              <span className="info-label">Inventory Count</span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleCreate}
            disabled={creating || !inventoryName.trim()}
          >
            {creating ? 'Creating...' : 'Create Inventory'}
          </button>
        </div>
      </div>
    </>
  );
};

export default FullInventoryForm;
